import defaultPaginationStrategy from './default';
// import intercategoryPaginationStrategy from './intercategory';

// eslint-disable-next-line import/prefer-default-export
export { defaultPaginationStrategy };
